import { ConfirmationModal } from '@/common/components/modals/ConfirmationModal';
import { useTranslation } from 'react-i18next';

interface CommentDeleteModalProps {
    opened: boolean;
    onClose: () => void;
    onConfirm: (commentId: string) => void;
    targetId: string; // comment Id
    hasReply: boolean;
}

const CommentDeleteModal = ({
    opened,
    onClose,
    onConfirm,
    targetId,
    hasReply,
}: CommentDeleteModalProps) => {
    const { t } = useTranslation(['common', 'comment']);

    return (
        <ConfirmationModal
            opened={opened}
            onClose={() => {
                onClose();
            }}
            onConfirm={() => {
                onConfirm(targetId);
                onClose();
            }}
            title={t('comment:modal.delete.title')}
            message={
                hasReply
                    ? t('comment:modal.delete.reply_message')
                    : t('comment:modal.delete.message')
            }
            confirmText={t('common:action.delete')}
            cancelText={t('common:button.cancel')}
            confirmButtonColor="red"
        ></ConfirmationModal>
    );
};

export default CommentDeleteModal;
